// let nav = ''

// if ((navigator.userAgent.indexOf('iPhone') != -1)) {
//     nav = "https://apps.apple.com/cn/app/弹壳特攻队/id1628270358"
// } else {
//     // navigator.userAgent.match(/Android/i)
//     nav = "https://danke.habby.cn/download/official/and.apk"
// }

export const urls = {
    "ios": "https://apps.apple.com/cn/app/弹壳特攻队/id1628270358",
    "and": "https://danke.habby.cn/download/official/and.apk",
}


// WEBPACK FOOTER //
// ./src/tool/url.js